import { render, staticRenderFns } from "./cate-item.vue?vue&type=template&id=5463a789&scoped=true&"
import script from "./cate-item.vue?vue&type=script&lang=js&"
export * from "./cate-item.vue?vue&type=script&lang=js&"
import style0 from "./cate-item.vue?vue&type=style&index=0&id=5463a789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463a789",
  null
  
)

export default component.exports